import Vue from 'vue';
import Vuex from 'vuex';
import { createLogger } from 'vuex';
import * as modules from './modules';
import { isProd } from '@/utils/environment';
import { teamWatcherPlugin } from './plugins/teamWatcherPlugin';
import { gtmPlugin } from './plugins/gtm';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  plugins: isProd ? [teamWatcherPlugin, gtmPlugin] : [createLogger(), teamWatcherPlugin, gtmPlugin]
});

export const useStore = () => store;

export default store;
